module.exports = __webpack_public_path__ + "img/20c8a2c49e8d55de6b7fdd539f1c15ea.20c8a2c4.png";